import { CaptureLocator, CaptureView } from '../../models/object-capture.model';

/** Einstufung einer Aufnahme; Live-Ansicht und Abnahme sollen gleich einstufen. */
export type CapturePill = 'stable' | 'positionOnly' | null;

const STABLE_CSS_PREFIXES = ['[data-testid=', '[data-test=', '#'];

export function isPassword(capture: CaptureView): boolean {
  return capture.inputType?.toLowerCase() === 'password';
}

/**
 * „stabil“: der erste Kandidat haengt an Test-Attribut, id oder Rolle. „nur Position“: es gibt nur
 * absolute XPath-Pfade, wie sie engine-browser als letzten Ausweg bildet (beginnen mit einem `/`).
 */
export function pillOf(locators: CaptureLocator[]): CapturePill {
  const first = locators[0];
  if (!first) return null;
  if (first.strategy === 'role') return 'stable';
  if (first.strategy === 'css' && STABLE_CSS_PREFIXES.some((prefix) => first.value.startsWith(prefix))) {
    return 'stable';
  }
  const positional = locators.every((l) => l.strategy === 'xpath' && !l.value.startsWith('//'));
  return positional ? 'positionOnly' : null;
}

/** Vorschlag oder Rolle mit zugaenglichem Namen; null, wenn beides fehlt. */
export function defaultName(capture: CaptureView): string | null {
  return capture.suggestedName || [capture.role, capture.accessibleName].filter(Boolean).join(' ') || null;
}
